import { render, staticRenderFns } from "./block-credit.vue?vue&type=template&id=19ec6e44&scoped=true"
import script from "./block-credit.vue?vue&type=script&lang=js"
export * from "./block-credit.vue?vue&type=script&lang=js"
import style0 from "./block-credit.vue?vue&type=style&index=0&id=19ec6e44&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19ec6e44",
  null
  
)

export default component.exports